module.exports = __webpack_public_path__ + "img/sale-path-blue.59afdf58.png";